module.exports = __webpack_public_path__ + "img/layanan-mobil.f43a5469.webp";